import React from 'react';
import { Box } from '@common-fe/common-fe';

import { ROUTES } from '@/common';
import { useBreadcrumbs } from '@/modules/core/hooks/useBreadcrumbs';

import useGetEmployerPlans from './hooks/useGetEmployerPlan';
import EmployerDashboardTopbarContainer from './AccountUsageTopbar';
import EmployerClaimSpendContainer from './EmployerClaimSpend';
import EmployerPlanDetailsContainer from './EmployerPlanDetails';
import EmployerServiceCategoriesContainer from './EmployerServiceCategories';
import EmployerStatisticsContainer from './EmployerStatistics';
interface Props {
  planId: string;
  planYearId: string;
}
const EmployerDashboardContainer: React.FC<Props> = ({ planId, planYearId }) => {
  const { foundPlan, isLoading, plans, currentPlan, setCurrentPlan, isHSA } = useGetEmployerPlans({
    planId,
    planYearId,
  });

  useBreadcrumbs(
    [
      {
        route: ROUTES.ACCOUNT_USAGE_DASHBOARD(planId),
        title: `${foundPlan?.name || ''} Usage`,
      },
    ],
    [foundPlan?.name]
  );
  return (
    <Box direction="column">
      <EmployerDashboardTopbarContainer
        value={currentPlan}
        onChangeValue={setCurrentPlan}
        foundPlan={foundPlan}
        isLoading={isLoading}
        options={plans}
      />
      <EmployerStatisticsContainer planId={currentPlan as string} isLoading={isLoading} isHSA={isHSA} />
      <Box round="container1Round" background="module" pad="spacing16" margin={{ top: 'spacing12' }}>
        <EmployerClaimSpendContainer planId={currentPlan as string} isHSA={isHSA} isLoading={isLoading} />
        <Box margin={{ top: 'spacing16' }}>
          <EmployerServiceCategoriesContainer planId={currentPlan as string} />
        </Box>
        <Box margin={{ top: 'spacing16' }}>
          <EmployerPlanDetailsContainer planId={currentPlan as string} isHSA={isHSA} isLoading={isLoading} />
        </Box>
      </Box>
    </Box>
  );
};

export default EmployerDashboardContainer;
